// Vue
import { Vue, Component, Prop, Inject } from "vue-property-decorator";

// Template
import template from "./template.vue";

// Base Module
import ModuleBase from "#/common/ModuleBase";

// Components
import { Observer } from "mobx-vue";
import { BodyBuilder } from "../../../common/interfaces/conversionworld/BodyBuilder";
import { ContentModule } from "../../common/content_module/ContentModule";
import { reaction } from "mobx";
import ModuleWrapper from "../../../components/module_wrapper/ModuleWrapper";
import { ImageAspectRatio } from "../../../components/image_aspect_ratio/ImageAspectRatio";
import { StoryLink } from "../../common/story_link/StoryLink";

@Observer
@Component({
  mixins: [template],
  components: {
    ModuleWrapper,
    ImageAspectRatio,
    StoryLink,
  },
})
export class ProductBodybuilderTeaserModule extends ModuleBase {
  getBackgroundColorFromInstance(instance: object): string {
    let color = "white";

    if (this.currentProduct) {
      color = this.currentProduct.is_van_solution ? "black" : "white";
    }

    if (instance["color"]) {
      color = instance["color"];
    }

    return color;
  }

  get currentProduct() {
    return this.$store.conversionWorldProduct.current;
  }

  get bodybuilder() {
    if (this.currentProduct) {
      return this.currentProduct.bodybuilder;
    }

    return null;
  }

  get isVanSolution() {
    if (this.currentProduct) {
      return this.currentProduct.is_van_solution;
    }

    return false;
  }

  get name() {
    if (this.bodybuilder) {
      return this.bodybuilder.name;
    }

    return null;
  }

  get link() {
    if (this.bodybuilder && this.bodybuilder.is_approved) {
      return (
        "/" +
        this.lang +
        "/partner-aufbauhersteller/" +
        this.bodybuilder.id +
        "/" +
        this.bodybuilder.slug
      );
    }

    return "#";
  }
}
